import { render, staticRenderFns } from "./AddTransactionView.vue?vue&type=template&id=0b574b3b"
import script from "./AddTransactionView.vue?vue&type=script&lang=js"
export * from "./AddTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports